import api from "../../../api";
import {typedQuery} from "../../typing";

export const thirdPartyTags = typedQuery(["tprm", "thirdPartyTags"], async () => {
  return await api.tprm.thirdPartyTags.list();
});
